import styled from 'styled-components';
import Header from './Header';
import { mediaQueries } from '../shared/config'
import landing from "../images/landing.gif"

const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 100vh;
    ${mediaQueries.tablet} {
        min-height: 50vh;
  }
    @media (max-width: 700px){

        justify-content: center;
        min-height: 40vh;
    }
`
const Illo = styled.img`
    max-width: 100vw;
    height: auto;
    background-size: cover;
    object-fit: cover;
`

const Credits = styled.div`
    font-family: Optima regular font;
    color: #E5E5E5;
    text-align: right;
    font-style: italic;
    align-items: right;
    justify-content: right;
    margin-left: 70%;
    padding-bottom: 15%;
    ${mediaQueries.mobile} {
        margin-left: 50%;
        font-size: 12px;
        padding-bottom: 0px;
  }
`

export default function Landing(props){
    return(
        
        <>
            <Header/>
            <Container>
                <Illo src={landing} />
                <Credits>
                    (Isabella Lee/Daily Bruin staff)
                </Credits>
            </Container>
            
        </>
        

    );
}